import { useEffect } from "react";

import { useSetAtom } from "../../app-jotai";
import { currentUserAtom, workspaceApi } from "../../data/workspace";

import { AuthDialog } from "./AuthDialog";
import { DashboardDialog } from "./DashboardDialog";
import { PresentationOverlay } from "./PresentationOverlay";

/**
 * Top-level workspace UI, rendered as a child of <Excalidraw> only when the
 * workspace backend is configured. Bootstraps the signed-in user and mounts
 * the auth/dashboard dialogs and the presentation overlay.
 */
export const WorkspaceRoot = () => {
  const setCurrentUser = useSetAtom(currentUserAtom);

  useEffect(() => {
    workspaceApi
      .me()
      .then((r) => setCurrentUser(r.user))
      .catch(() => setCurrentUser(null));
  }, [setCurrentUser]);

  return (
    <>
      <AuthDialog />
      <DashboardDialog />
      <PresentationOverlay />
    </>
  );
};
